export { default as AccessRoutes } from './AccessRoutes';
export const ACCESS_BASE_ROUTES = '/access';
export const ROLES_BASE_ROUTES = '/roles';
export const ENTITIES_BASE_ROUTES = '/entities';
